import React from "react";

const routes: IRoute[] = [
  {
    path: "/",
    component: () => import("layouts/BasicLayout"),
    routes: [
      {
        path: "/login",
        component: () => import("pages/login"),
      },
      {
        path: "/tourist",
        component: () => import("pages/tourist"),
      },
      {
        path: "/sso",
        component: () => import("pages/sso"),
      },
      {
        path: "/welcome",
        component: () => import("pages/welcome"),
      },
      {
        path: "/chat",
        component: () => import("pages/chat"),
      },
      {
        path: '/aichat',
        component: () => import('pages/aichat')
      },
      {
        path: "/im",
        component: () => import("pages/IM"),
      },
      {
        path: "/teams-login",
        component: () => import("pages/TeamsLogin"),
      },
      {
        path: "/wecom-login",
        component: () => import("pages/WeComLogin"),
      },
      {
        path: "/agreement",
        component: () => import("pages/Agreement"),
      },
      {
        path: "/agreement-us",
        component: () => import("pages/AgreementUS"),
      },
      {
        path: "/user-services-agreement-us",
        component: () => import("pages/UserServicesAgreementUS"),
      },
      {
        path: "/manual",
        component: () => import("pages/Manual"),
      },
      {
        path: "/user-services-agreement",
        component: () => import("pages/UserServicesAgreement"),
      },
      { path: "/version", component: () => import("pages/Version") },
      { path: "/aduit", component: () => import("pages/noLoginPages/audit") },
    ],
  },
];

function addLazyComponent(routes: IRoute[]) {
  routes.forEach((route) => {
    route.component = React.lazy(route.component);
    if (route.routes) {
      addLazyComponent(route.routes);
    }
  });
}
addLazyComponent(routes);
export default routes;
